export var QuestionnaireHistory;
(function (QuestionnaireHistory) {
    QuestionnaireHistory["HISTORY"] = "QuestionnaireHistory/History";
    QuestionnaireHistory["HISTORY_SUCESSFUL"] = "QuestionnaireHistory/History_Sucessful";
    QuestionnaireHistory["RESPONSE_HISTORY_1"] = "QuestionnaireHistory/Response_1_History";
    QuestionnaireHistory["RESPONSE_HISTORY_1_SUCESSFUL"] = "QuestionnaireHistory/Response_1_History_Sucessful";
    QuestionnaireHistory["RESPONSE_HISTORY_2"] = "QuestionnaireHistory/Response_2_History";
    QuestionnaireHistory["RESPONSE_HISTORY_2_SUCESSFUL"] = "QuestionnaireHistory/Response_2_History_Sucessful";
})(QuestionnaireHistory || (QuestionnaireHistory = {}));
